import type { ImageCarouselSlide } from './types';
import HotelImageUrl from '@assets/images/certificates/hotel.png';
import CondoImageUrl from '@assets/images/certificates/condo.png';
import CruiseImageUrl from '@assets/images/certificates/cruise.png';

export const PLACEHOLDER_IMAGE =
  'https://travcoding-hotel-resources.s3.us-east-1.amazonaws.com/not_image_property.jpg';

export const DEFAULT_SLIDES: ImageCarouselSlide[] = [
  {
    id: 'hotel',
    headingId: 'certificates.carousel.hotel.heading',
    descriptionId: 'certificates.carousel.hotel.description',
    imageSrc: HotelImageUrl,
    imageAltId: 'certificates.carousel.hotel.imageAlt',
  },
  {
    id: 'condo',
    headingId: 'certificates.carousel.condo.heading',
    descriptionId: 'certificates.carousel.condo.description',
    imageSrc: CondoImageUrl,
    imageAltId: 'certificates.carousel.condo.imageAlt',
  },
  {
    id: 'cruise',
    headingId: 'certificates.carousel.cruise.heading',
    descriptionId: 'certificates.carousel.cruise.description',
    imageSrc: CruiseImageUrl,
    imageAltId: 'certificates.carousel.cruise.imageAlt',
  },
];
